import Tippy from "@tippyjs/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as IconChat } from "../../assets/icons/ic_chat.svg";
import logo from "../../assets/images/logo.png";
import { SOCKET_LISTEN_TYPE } from "../../constants/soket-message";
import { TimeKeepingUserButtons } from "../../features/timekeeping-user/components/timekeeping-user-buttons";
import { useFetchData } from "../../hooks/useFetch";
import { Message } from "../../models/response/computers-response";
import { EmployeeNotificationHistoryResponse } from "../../models/response/employee-notification-history";
import { MODULE_ROUTE } from "../../routers/module-router";
import { API_DEVICE_TOKENS_ROUTER, API_EMPLOYEE_NOTIFICATION_HISTORY_ROUTER } from "../../services/api-config";
import { BasePaginateResponse, isSuccess } from "../../services/base-response";
import { useSocket } from "../../state/socket-service";
import { IRootState } from "../../store";
import {
  toggleCloseNotification,
  toggleSidebar,
  toggleSocketMessageNoti,
  toggleTheme,
} from "../../store/themeConfigSlice";
import CookieUtils from "../../utils/cookie-utils";
import { getDeviceUUID } from "../../utils/helpers";
import Dropdown from "../custom/drop-down";
import ImageCustom from "../custom/image-custom";
import IconBellBing from "../icons/icon-bell-bing";
import { IconX } from "../icons/icon-group";
import IconLaptop from "../icons/icon-laptop";
import IconLogout from "../icons/icon-logout";
import IconMenu from "../icons/icon-menu";
import IconMoon from "../icons/icon-moon";
import IconSun from "../icons/icon-sun";
import IconUser from "../icons/icon-user";

export const Header = () => {
  const navigate = useNavigate();
  const { socket } = useSocket();
  const dispatch = useDispatch();
  const changeMessageNoti = useSelector((state: IRootState) => state.themeConfig.socketMessageNoti);
  const closeNotification = useSelector((state: IRootState) => state.themeConfig.closeNotification);
  const [notification, setNotification] = useState<boolean>(false);
  const isRtl = useSelector((state: IRootState) => state.themeConfig.rtlClass) === "rtl";
  const themeConfig = useSelector((state: IRootState) => state.themeConfig);
  const [dataEmployeeNotificationHistory, setDataEmployeeNotificationHistory] = useState<
    EmployeeNotificationHistoryResponse[]
  >([]);
  const { request: onDeviceTokens, baseResponse: resDeviceToken } = useFetchData.Post();

  const { request: onGetNews, baseResponse: responsesNews } =
    useFetchData.Get<BasePaginateResponse<EmployeeNotificationHistoryResponse[]>>();

  useEffect(() => {
    if (socket) {
      socket.on(SOCKET_LISTEN_TYPE.MESSAGE_TEXT_RECEIVED, (dataMessage: Message) => {
        if (dataMessage) {
          if (dataMessage.sender._id !== CookieUtils.getCurrentUser()._id) {
            setNotification(true);
            // playNotificationSound();
          } else {
            setNotification(false);
          }
        }
      });
      // return () => {
      //   socket.off(SOCKET_LISTEN_TYPE.MESSAGE_TEXT_RECEIVED);
      // };
    }
  }, [socket]);

  useEffect(() => {
    if (changeMessageNoti === true) {
      setNotification(false);
      dispatch(toggleSocketMessageNoti(false));
    }
  }, [changeMessageNoti]);

  useEffect(() => {
    onGetNews({
      endPoint: API_EMPLOYEE_NOTIFICATION_HISTORY_ROUTER.API_GET_EMPLOYEE_NOTIFICATION_HISTORY,
      data: {
        limit: 5,
        page: 1,
        branch_id: "-1",
      },
    });
  }, []);

  useEffect(() => {
    if (!responsesNews) return;
    if (responsesNews.status === 200) {
      setDataEmployeeNotificationHistory(responsesNews.data.list);
    }
  }, [responsesNews]);

  const handleDeleteNotification = (id: string) => {
    setDataEmployeeNotificationHistory(dataEmployeeNotificationHistory.filter((item) => item._id !== id));
  };

  const handleRemoveDeviceTokens = () => {
    onDeviceTokens({
      endPoint: API_DEVICE_TOKENS_ROUTER.API_REMOVE_DEVICE_TOKENS(),
      data: {
        device_id: getDeviceUUID(),
      },
    });
  };

  useEffect(() => {
    if (!resDeviceToken) return;
    if (isSuccess(resDeviceToken)) {
    }
  }, [resDeviceToken]);

  return (
    <header className={`z-40 navbar${themeConfig.semidark && themeConfig.menu === "horizontal" ? "dark" : ""}`}>
      <div className="shadow-sm">
        <div className="relative bg-white flex w-full items-center px-5 py-2.5 dark:bg-black">
          <div className="flex justify-between items-center horizontal-logo lg:hidden ltr:mr-2 rtl:ml-2">
            <Link to={MODULE_ROUTE.MANAGEMENT_SERVICE} className="flex gap-2 items-center main-logo shrink-0">
              <ImageCustom isLocal className="inline h-9 rounded-full" url={logo} />
              <span className="text-sm font-semibold text-[#E96012] dark:text-white break-all max-w-[200px]">
                {CookieUtils.getCurrentUser().brand_name}
              </span>
            </Link>
            <button
              type="button"
              className="collapse-icon flex-none dark:text-[#d0d2d6] hover:text-primary dark:hover:text-primary flex lg:hidden ltr:ml-2 rtl:mr-2 p-2 rounded-full bg-white-light/40 dark:bg-dark/40 hover:bg-white-light/90 dark:hover:bg-dark/60"
              onClick={() => dispatch(toggleSidebar())}
            >
              <IconMenu className="w-5 h-5" />
            </button>
          </div>

          <div className="sm:flex-1 ltr:sm:ml-0 ltr:ml-auto sm:rtl:mr-0 rtl:mr-auto flex items-center space-x-1.5 lg:space-x-2 rtl:space-x-reverse dark:text-[#d0d2d6]">
            <p className="hidden flex-1 font-extrabold text-orange-600 uppercase lg:flex">{themeConfig.menuContent}</p>
            <TimeKeepingUserButtons />
            <div>
              <Tippy content="Chat">
                <button
                  className="flex relative items-center p-2 rounded-full bg-white-light/40 dark:bg-dark/40 hover:text-primary hover:bg-white-light/90 dark:hover:bg-dark/60"
                  onClick={() => navigate(MODULE_ROUTE.CHAT)}
                >
                  <IconChat />
                  {notification && (
                    <span className="flex absolute top-0 w-5 h-5 ltr:right-0 rtl:left-0">
                      <span className="animate-ping absolute ltr:-left-[5px] rtl:-right-[5px] -top-[5px] inline-flex h-full w-full rounded-full bg-red-700/50 opacity-75"></span>
                      <span className="relative inline-flex rounded-full w-[12px] h-[12px] bg-red-600"></span>
                    </span>
                  )}
                </button>
              </Tippy>
            </div>
            <Tippy content="Chuyển chế độ">
              <div>
                {themeConfig.theme === "light" && (
                  <button
                    className={`${
                      themeConfig.theme === "light" &&
                      "flex items-center p-2 rounded-full bg-white-light/40 dark:bg-dark/40 hover:text-primary hover:bg-white-light/90 dark:hover:bg-dark/60"
                    }`}
                    onClick={() => dispatch(toggleTheme("dark"))}
                  >
                    <IconSun />
                  </button>
                )}
                {themeConfig.theme === "dark" && (
                  <button
                    className={`${
                      themeConfig.theme === "dark" &&
                      "flex items-center p-2 rounded-full bg-white-light/40 dark:bg-dark/40 hover:text-primary hover:bg-white-light/90 dark:hover:bg-dark/60"
                    }`}
                    onClick={() => dispatch(toggleTheme("system"))}
                  >
                    <IconMoon />
                  </button>
                )}
                {themeConfig.theme === "system" && (
                  <button
                    className={`${
                      themeConfig.theme === "system" &&
                      "flex items-center p-2 rounded-full bg-white-light/40 dark:bg-dark/40 hover:text-primary hover:bg-white-light/90 dark:hover:bg-dark/60"
                    }`}
                    onClick={() => dispatch(toggleTheme("light"))}
                  >
                    <IconLaptop />
                  </button>
                )}
              </div>
            </Tippy>
            <Tippy content="Thông báo">
              <div className="dropdown shrink-0">
                <Dropdown
                  offset={[0, 8]}
                  placement={`${isRtl ? "bottom-start" : "bottom-end"}`}
                  btnClassName="relative block p-2 rounded-full bg-white-light/40 dark:bg-dark/40 hover:text-primary hover:bg-white-light/90 dark:hover:bg-dark/60"
                  button={
                    <span onClick={() => dispatch(toggleCloseNotification(false))}>
                      <IconBellBing />
                      {closeNotification && (
                        <span className="flex absolute top-0 w-5 h-5 ltr:right-0 rtl:left-0">
                          <span className="animate-ping absolute ltr:-left-[5px] rtl:-right-[5px] -top-[5px] inline-flex h-full w-full rounded-full bg-red-700/50 opacity-75"></span>
                          <span className="relative inline-flex rounded-full w-[12px] h-[12px] bg-success"></span>
                        </span>
                      )}
                    </span>
                  }
                >
                  <ul className="!py-0 text-dark dark:text-white-dark w-[300px] sm:w-[350px] divide-y dark:divide-white/10">
                    <li onClick={(e) => e.stopPropagation()}>
                      <div className="flex justify-between items-center px-4 py-2 font-semibold">
                        <h4 className="text-lg">Thông báo</h4>
                      </div>
                    </li>
                    {dataEmployeeNotificationHistory.length > 0 ? (
                      <>
                        {dataEmployeeNotificationHistory.map((notification) => {
                          return (
                            <li
                              key={notification._id}
                              className="dark:text-white-light/90"
                              onClick={() => {
                                navigate(MODULE_ROUTE.EMPLOYEE_NOTIFICATION_HISTORY);
                                dispatch(toggleCloseNotification(false));
                              }}
                            >
                              <div className="flex items-center px-4 py-2 group">
                                <div className="flex flex-auto ltr:pl-3 rtl:pr-3">
                                  <div className="ltr:pr-3 rtl:pl-3">
                                    <h6
                                      dangerouslySetInnerHTML={{
                                        __html: notification.content,
                                      }}
                                    ></h6>
                                    <span className="block text-xs font-normal dark:text-gray-500">
                                      {notification.created_at}
                                    </span>
                                  </div>
                                  <button
                                    type="button"
                                    className="opacity-0 ltr:ml-auto rtl:mr-auto text-neutral-300 hover:text-danger group-hover:opacity-100"
                                    onClick={() => handleDeleteNotification(notification._id)}
                                  >
                                    <IconX />
                                  </button>
                                </div>
                              </div>
                            </li>
                          );
                        })}
                        <li>
                          <div className="p-4">
                            <button
                              className="block w-full btn btn-primary btn-small"
                              onClick={() => {
                                navigate(MODULE_ROUTE.EMPLOYEE_NOTIFICATION_HISTORY);
                                dispatch(toggleCloseNotification(false));
                              }}
                            >
                              Đọc tất cả thông báo
                            </button>
                          </div>
                        </li>
                      </>
                    ) : (
                      <li onClick={(e) => e.stopPropagation()}>
                        <button
                          type="button"
                          className="!grid place-content-center hover:!bg-transparent text-lg min-h-[200px]"
                        >
                          <div className="mx-auto mb-4 rounded-full ring-4 ring-primary/30 text-primary">
                            <IconX className="w-10 h-10" />
                          </div>
                          Không có dữ liệu
                        </button>
                      </li>
                    )}
                  </ul>
                </Dropdown>
              </div>
            </Tippy>
            <Tippy content="Thông tin cá nhân">
              <div className="flex dropdown shrink-0">
                <Dropdown
                  offset={[0, 8]}
                  placement={`${isRtl ? "bottom-start" : "bottom-end"}`}
                  btnClassName="relative group block"
                  button={
                    <ImageCustom
                      className="object-cover rounded-full w-9 h-9 saturate-50 group-hover:saturate-100 border border-[#f2f2f2]"
                      isLocal={false}
                      url={CookieUtils.getCurrentUser().avatar ?? ""}
                    />
                  }
                >
                  <ul className="text-dark dark:text-white-dark !py-0 w-[230px] font-semibold dark:text-white-light/90">
                    <li>
                      <div className="flex items-center px-4 py-4">
                        <ImageCustom
                          className="object-cover w-10 h-10 rounded-md border border-[#f2f2f2]"
                          isLocal={false}
                          url={CookieUtils.getCurrentUser().avatar ?? ""}
                        />
                        <div className="truncate ltr:pl-4 rtl:pr-4">
                          <h4 className="text-base">
                            {CookieUtils.getCurrentUser().name ?? ""}
                            <span className="px-1 text-xs rounded bg-success-light text-success ltr:ml-2 rtl:ml-2">
                              Pro
                            </span>
                          </h4>
                        </div>
                      </div>
                    </li>
                    <li>
                      <Link to={MODULE_ROUTE.PROFILE} className="dark:hover:text-white">
                        <IconUser className="w-4.5 h-4.5 ltr:mr-2 rtl:ml-2 shrink-0" />
                        Tài khoản của tôi
                      </Link>
                    </li>
                    {/* <li>
                      <Link to={MODULE_ROUTE.TIMELINE} className="dark:hover:text-white">
                        <IconHistory className="w-5 h-5 ltr:mr-2 rtl:ml-2 shrink-0" />
                        Lịch sử hoạt động
                      </Link>
                    </li> */}
                    <li className="border-t border-white-light dark:border-white-light/10">
                      <a
                        href="/#"
                        onClick={(e) => {
                          e.preventDefault();
                          CookieUtils.eraseCookie("user");
                          CookieUtils.eraseCookie("domain");
                          CookieUtils.eraseCookie("branch_id");
                          CookieUtils.eraseCookie("privilege_codes");
                          CookieUtils.eraseCookie("privilege_codes");
                          CookieUtils.eraseCookie("tokenNotification");
                          window.location.href = MODULE_ROUTE.LOGIN;
                          handleRemoveDeviceTokens();
                        }}
                        className="text-danger !py-3"
                      >
                        <IconLogout className="w-4.5 h-4.5 ltr:mr-2 rtl:ml-2 rotate-90 shrink-0" />
                        Đăng xuất
                      </a>
                    </li>
                  </ul>
                </Dropdown>
              </div>
            </Tippy>
          </div>
        </div>
      </div>
    </header>
  );
};
